module.exports = __webpack_public_path__ + "media/images/flags/GR-eb5b8d57d5a9a7139d4dd595b0aaee42.svg";